import { render, staticRenderFns } from "./boardPPR.vue?vue&type=template&id=1801983e&"
import script from "./boardPPR.vue?vue&type=script&lang=js&"
export * from "./boardPPR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QToolbarTitle,QBtnDropdown,QMarkupTable,QToggle,QCard,QCardSection,QSelect,QIcon,QSeparator,QCardActions,QBtn,QInput} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QToolbarTitle,QBtnDropdown,QMarkupTable,QToggle,QCard,QCardSection,QSelect,QIcon,QSeparator,QCardActions,QBtn,QInput}, component.options.components || {})
